module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/header_cover-59cfd164e48197a2d2a74e200a9cdc27.webp";